export class ConfiguracaoEmail {
  id: number;
  display: string;
  senha: string;
  porta: number;
  email: string;
  host: string;
  ativo: boolean;
}
